module.exports = __webpack_public_path__ + "static/assets/06bdea143d1e4b4e7bdc786e363270f8.svg";